module.exports = __webpack_public_path__ + "static/recipe-collect-3-1bfe492df17e0139a8fe9b8d2dbf36b0.jpeg";